<div class="ps-mat-input">
    <textarea [id]="controlName" [autocomplete]="controlName" [attr.rows]="rows" [value]="value" [maxLength]="maxlength" [attr.required]="required ? true : false" [readOnly]="readonly" (input)="onInput($event)" (blur)="onTouched()"></textarea>
    <label [attr.for]="controlName"><span class="text-danger" *ngIf="required">*</span> {{ label }}</label>
</div>

<div *ngIf="required && showRequiredMsg && (parentForm.controls[controlName].dirty || parentForm.controls[controlName].touched)"
class="text-danger text-sm">
<span *ngIf="parentForm.controls[controlName].errors?.['required']">*{{label != null || label != '' ? label : 'This field'}} is required<br /></span>
</div>